import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';

const { getAllowCookies, hasDoneCookieInit } = require('./../cookieUtils');

class CookieView extends React.Component {

    constructor(props) {
        super(props);
         
        this.state = {
            custom: false
        }
    }

    clickCustom() {
        this.setState({custom: !this.state.custom});
    }

    render() {
        // Cookie consent dialog 1.0
        if (hasDoneCookieInit()) {
            if (getAllowCookies())
                return (
                    <div class="darkBack" id="main">
                    
                        <div class="tutorialPrivacyPopup2">
                            <h3>
                                Cookie / Server Data Preferences: (Enabled)
                            </h3>

                            Traitors.sh uses a single cookie and entries in our server's database to remember your ranked score and nickname.<br/><br/>
                            This cookie and server data is currently enabled.  If you disable it, we will delete the cookie off your computer and delete your ranked and nickname data off of our server.
                            For more information, see our <a style={{color: "rgb(200, 200, 255)"}} href="https://traitors.sh/resources/privacy.html" target="_blank">Privacy Policy.</a><br/><br/>
                            If you are not old enough to consent to data processing in your location, or if you wish to remove your data from our servers, click "Disable and Delete Data".<br/><br/>
                            <br/>
                            <span class="allowButton" onClick={this.props.clickYes}>Keep Enabled</span>
                            <span class="privacyButton" onClick={this.props.clickNo}>Disable and Delete Data</span>
                            <br/><br/>

                        </div>
                    </div>
                );
            else
                return (
                    <div class="darkBack" id="main">
                    
                        <div class="tutorialPrivacyPopup2">
                            <h3>
                                Cookie / Server Data Preferences: (Disabled)
                            </h3>

                            Traitors.sh uses a single cookie and entries in our server's database to remember your ranked score and nickname.<br/><br/>
                            This cookie and server data is currently disabled.  If you enable it, you will be added to our server and we will begin saving your ranked score.
                            For more information, see our <a style={{color: "rgb(200, 200, 255)"}} href="https://traitors.sh/resources/privacy.html" target="_blank">Privacy Policy.</a><br/><br/>
                            If you are not old enough to consent to data processing in your location, do not enable our cookie and server data.<br/><br/>
                            <br/>
                            <span class="allowButton" onClick={this.props.clickYes}>Enable</span>
                            <span class="privacyButton" onClick={this.props.clickNo}>Keep Disabled</span>
                            <br/><br/>
                        </div>
                    </div>
                );
        }

        return (
            <div class="darkBack" id="main">
            
                <div class="tutorialPrivacyPopup2">
                    <h3>
                        Cookie / Server Data Preferences:
                    </h3>

                    Traitors.sh uses a single cookie and entries in our server's database to remember your ranked score and nickname.<br/><br/>
                    You can still play our game without this data but some features like ranked mode and nickname recall won't be available.
                    For more information, see our <a style={{color: "rgb(200, 200, 255)"}} href="https://traitors.sh/resources/privacy.html" target="_blank">Privacy Policy.</a><br/><br/>
                    If you are not old enough to consent to data processing in your location, please click "Don't Allow".<br/><br/>
                    <br/>
                    <span class="allowButton" onClick={this.props.clickYes}>Allow</span>
                    <span class="privacyButton" onClick={this.props.clickNo}>Don't Allow</span>
                    <br/>
                    <br/>
                    <div class="subPrivacyText">
                        You can change this setting later through our Cookie / Data Preferences.
                    </div>
                </div>
            </div>
        );
    }
}

export default CookieView;